import { TreeNode } from '../../hooks/stores/launcherElementsStore';

export const findNodeIndex = (treeNodes: TreeNode[], idToFind: string): number | undefined => {
  for (let i = 0; i < treeNodes.length; i++) {
    const treeNode = treeNodes[i];
    if (treeNode.id === idToFind) {
      return i;
    }

    if (treeNode.children) {
      const result = findNodeIndex(treeNode.children, idToFind);
      if (result !== undefined) {
        return result;
      }
    }
  }

  return undefined;
};